var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.widgetReady)?_c('div',[_c('div',{ref:"map",staticStyle:{"width":"100%","height":"600px"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }